import { ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AngularFireStorage } from "@angular/fire/compat/storage"
import { NgForm } from '@angular/forms';
import { GeneralService } from '../services/general.service';
import { Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgxGaugeCap, NgxGaugeType } from 'ngx-gauge/gauge/gauge';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js/auto';
import { DatePipe } from '@angular/common';

// import * as htmlToImage from 'html-to-image';
// import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';


import * as pdfMake from '../../assets/pdfmake/pdfmake';
import  pdfFonts from '../../assets/pdfmake/vfs_fonts';
import { HttpClient } from '@angular/common/http';
import { windowWhen } from 'rxjs';
import { LoaderServiceService } from '../services/loaderService.service';
import { fonts } from 'app/config/pdfFonts';
import { environment } from 'environments/environment';
import { GlobalErrorHandler } from 'app/services/global-error-handler';
import Swal from 'sweetalert2';

pdfMake.vfs = pdfFonts.pdfMake.vfs;


@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  providers: [DatePipe]

})

export class ReportsComponent implements OnInit {

  colorarray = [
    'rgba(255, 197, 0, 0.79)',
    'rgba(0, 17, 206, 0.79)',
    'rgba(0, 144, 151, 0.79)',
    'rgba(234,50,186,0.79)',
    'rgba(151,106,84,0.94)',
    'rgba(68,179,96,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,223,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)',
    'rgba(65,165,96,0.61)',
    'rgba(197,164,181,0.38)',
    'rgba(86,43,223,0.76)',
    'rgba(23,67,106,0.43)',
    'rgba(177,198,20,0.84)',
    'rgba(10,163,169,0.59)',
    'rgba(72,42,203,0.86)',
    'rgba(153,173,23,0.32)',
    'rgba(234,50,156,0.79)',
    'rgba(151,106,14,0.94)',
    'rgba(68,179,66,0.61)',
    'rgba(214,177,181,0.38)',
    'rgba(123,76,23,0.76)',
    'rgba(27,89,106,0.43)',
    'rgba(155,200,20,0.84)',
    'rgba(10,123,169,0.59)',
    'rgba(52,91,221,0.86)',
    'rgba(112,29,145,0.32)',
    'rgba(225,138,60,0.79)',
    'rgba(130,75,84,0.94)'];

  @ViewChild('branchSelect') branchSelect: NgSelectComponent; // Reference to the ng-select component
  @ViewChild('moduleSelect') moduleSelect: NgSelectComponent; // Reference to the ng-select component
  @ViewChild('form') form: NgForm; // Reference to the form
  @ViewChildren('canvas') canvases: QueryList<ElementRef>;
  @ViewChild('chart', { static: false }) chartRef: ElementRef;
  audit: any[] = [];
  currentuser: any;
  client: any;
  clientmodule: any[] = [];
  clientaudit: any[] = [];
  dataSource: any;

  gaugeType: NgxGaugeType = 'semi';
  gaugeValue: number;
  gaugeAppendText: string = "%";
  cap: NgxGaugeCap = 'butt'
  markerConfig = {
    "0": {
      "color": "#555",
      "size": 5,
      "label": "0",
      "type": "line"
    },

    "20": {
      "color": "#555",
      "size": 5,
      "label": "20",
      "type": "line"
    }
    ,
    "40": {
      "color": "#555",
      "size": 5,
      "label": "40",
      "type": "line"
    },
    "60": {
      "color": "#555",
      "size": 5,
      "label": "60",
      "type": "line"
    },
    "80": {
      "color": "#555",
      "size": 5,
      "label": "80",
      "type": "line"
    },
    "100": {
      "color": "#555",
      "size": 5,
      "label": "100",
      "type": "line"
    }
  }
  displayedColumns: string[] = ['startdate', 'enddate', 'download'];
  data: object[] = [];
  totalauditpionts: number;
  allscorequestions: number;
  content: any[] = [];

  id: any;
  Branches: any;


  startDate: Date;
  endDate: Date;
  selectedModule: any;
  selectedBranch: any;
  clientmoduleSelected: boolean = false;
  branchSelected: boolean = false;
  selectedModuleval: any;
  selectedBranchval: any;
  audits: any[] = [];
  selectedModuleName: any;
  selectedBranchName: any;
  auditForDownload: any;
  ActionPlanOpen: any;
  ActionPlanClose: any;
  ActionPlanUnderProcess: any;
  labelsVchart: any[];
  DataVchart: any[];
  labelsHchart: any[];
  DataHchart: any[];
  DataSandtardcompilationdoughnut: any[];
  auditCharts: any;
  toalpercentaudit: string;
  auditerdata: any;
  pdfObj: any;
  documentDefinition: any[]=[];
  vbarChartBase64: string;
  hbarChartBase64: string;
  actionPlanDoughnutChartBase64: string;
  sandtardCompilationDoughnutChartBase64: string;
  view:boolean = false;
  createBarChart: Chart<"bar", any, unknown>;
  createvBarChart: Chart<"bar", any, unknown>;
  actionPlanDoughnutChart: Chart<"doughnut", any[], string>;
  sandtardCompilationDoughnutChart: Chart<"doughnut", any, string>;
  createdate: string;
  today:Date = new Date();
  actionplanstatus: boolean = true;
  createhbarCharthieght: number;



  constructor(private datePipe: DatePipe,private LoaderServiceService:LoaderServiceService,private http: HttpClient,private cdr: ChangeDetectorRef, public GeneralService: GeneralService, public ref: AngularFireStorage, public router: Router) {




    var clientdata = JSON.parse(localStorage.getItem('ClientData'));
    this.createdate = this.datePipe.transform(clientdata.createdDate, 'yyyy-MM-dd')!;

    this.clientmoduleSelected = false; // Reset clientmodule selection status
    this.branchSelected = false;
    this.currentuser = JSON.parse(localStorage.getItem("currentuser"));
    
    if (this.currentuser.role == "admin") {
      this.id = localStorage.getItem("userid")
    }
    else {
      this.id = this.currentuser.clientid;
    }
    this.getclientbyid();
    this.getBranchByClientId();
  }
  // checkFirestoreStats() {
  //   console.log('Firestore Error Stats:', this.errorHandler.getFirestoreErrorStats());
  // }

  // resetErrorCount() {
  //   this.errorHandler.resetErrorCount();
  // }











   async generatePDF(item?): Promise<void> {
   
  const fonts = {
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
      },
      Cairo: {
        normal: 'Cairo-Regular.ttf',
      }
    };
    var dd = {
      pageSize: 'A4',
      pageMargins: [40, 40, 40, 40],
      content: this.content,
      defaultStyle: {
        font: 'Cairo'
      },
      styles: {
        rtlStyle: {
          dir: 'rtl', // Crucial for RTL layout
          fontSize: 12,
          alignment: 'right'
        },
      },
    }
 
    pdfMake.createPdf(dd,null,fonts).open();
    this.content =[];
              this.LoaderServiceService.hide();

  }
  isArabic(text: string): boolean {
    // Check if the text contains Arabic characters
    return /[\u0600-\u06FF]/.test(text);
  }
  reverseText(text: string): string {
    if (!this.isArabic(text)) {
      // Return the text unchanged if it's not Arabic
      return text;
    }
    const singleLineText = text.replace(/\n+/g, ' ').trim();

    // Normalize spaces
    const normalizedText = singleLineText.replace(/\s+/g, ' ');

    // Split the text into words
    const words = normalizedText.split(' ');

    // Reverse the order of words
    const reversedWords = words.reverse();

    // Join the reversed words back into a single line
    return reversedWords.join(' ');
  }

  private getImageData(url: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      this.http.get(url, { responseType: 'blob' }).subscribe(response => {
        const reader = new FileReader();
        reader.onloadend = () => {
          resolve(reader.result as string);
        };
        reader.onerror = () => {
          reject(reader.error);
        };
        reader.readAsDataURL(response);
      }, error => {
        reject(error);
      });
    });
  }


  // private getImageData(url: string): Promise<string> {
  //   return fetch(url, { mode: 'no-cors' })
  //     .then(response => response.blob())  // Fetch image as Blob
  //     .then(blob => {
  //       return new Promise<string>((resolve, reject) => {
  //         const reader = new FileReader();
          
  //         reader.onloadend = () => {
  //           resolve(reader.result as string);  // Return the Base64 string
  //         };
          
  //         reader.onerror = (error) => {
  //           reject(error);  // Reject on FileReader error
  //         };
          
  //         reader.readAsDataURL(blob);  // Read the Blob as Base64
  //       });
  //     });
  // }
  




  

  




 



    imagelogo = environment.logoBase64;
  



  async  fetchImageDataForQuestions(item) {
    // Array to store all promises for image fetching
    let promises = [];
  
    var countallquestions = 0;
    var allscorequestions = 0; 
   

    for (let index = 0; index < item.module.categories.length; index++) {
      var scorequestions = 0;
      var total_questions = 0;
    

      for (let i = 0; i < item.module.categories[index].questions.length; i++) {
        let question = item.module.categories[index].questions[i];
        let photos = [];
   
            if (question.answerindex == "na") {
            } else {
              allscorequestions += question.score;
              scorequestions +=question.score;
              total_questions += 1;

              countallquestions += 1;
            }
        for (let ii = 0; ii < question.images.length; ii++) {
          // Push each getImageData promise into the promises array
          promises.push(
            this.getImageData(question.images[ii].url)
              .then((imageData) => {
                photos.push({
                  border:[false,false,false,false],
                  image: imageData,
                  width: 100,
                  height: 100
                });
              })
              .catch((error) => {
                console.error(`Error fetching image data for question ${question.id}: ${error.message}`);
              })
          );
        }
  
        // Wait for all image fetching promises to resolve
        await Promise.all(promises);
        question.photos = photos;
        this.totalauditpionts = countallquestions * item.module.quesfullscore;
        this.allscorequestions = allscorequestions;
        var toalpercentaudit = (
          (this.allscorequestions * 100) /
          this.totalauditpionts
        ).toFixed(1);

      }
      item.module.categories[index].score=scorequestions;
       item.module.categories[index].totalQuestionScore=total_questions * item.module.quesfullscore;
       item.module.categories[index].percentCat = ((scorequestions * 100) / (total_questions * item.module.quesfullscore)).toFixed(1);
    }
    let imagelogo
    console.log(localStorage.getItem("ClientLogo"))
    if (localStorage.getItem("ClientLogo")) {
      imagelogo = localStorage.getItem("ClientLogo")
    }
    else{
imagelogo = this.imagelogo;
    }
   
    this.content.push(
      {
        image: imagelogo,
        width: 100, // Adjust the width as needed
        alignment: 'left', // Align the image to the left
        margin: [0, 0, 0, 10], // Add margin below the image
      },
      {
        table: {
          body: [
            {
              border: [false, false, false, false],
              text: "I - monitor - Egypt. "
             },
    
          ],
        },
      },
      {
        table: {
          widths: ["35%", "45%", "20%"],
          body: [
            [
              { fillColor: "#eeeeee", alignment: "center", text: "Audit Info" },
              { fillColor: "#eeeeee", alignment: "center", text: "Audit Statistics" },
              {
                fillColor: "#eeeeee",
                alignment: "center",
                text: "singture info",
              },
            ],
            [
              {
                ul: [
                  "Module Name:"+this.selectedModuleName,
                  "Branch Name: " + this.selectedBranchName,
                  "Start Date:"+item.StartDate,
                  "End Date:"+ this.datePipe.transform(item.EndDate, 'yyyy-MM-dd')

                ],
              },
              {
                ul: [
                  "Auditor Name: " + this.auditerdata?.name,
                  "Auditor Email: " + this.auditerdata?.email,
                  "Score:" +
                    this.allscorequestions +
                    "/" +
                    this.totalauditpionts +
                    ":" +
                    toalpercentaudit +
                    "%",
                ],
              },
              {
                image:await this.getImageData(item.module.signtureurl),
                width: 100,
                height: 100,
              },
            ],
          ],
        },
      }
    );


    return item;
  }
  

  async getimage(item){
    console.log(item);
    console.log(item,"item before edit");
    this.fetchImageDataForQuestions(item)
   .then((modifiedItem) => {
    console.log(modifiedItem,"item after edit");
    for (let i = 0; i < modifiedItem.module.categories.length; i++) {
      this.content.push({
        table: {
          widths: ["70%", "10%", "10%", "10%"],
          heights: [10, 10],
          headerRows: 2,
          // keepWithHeaderRows: 1,
          body: [
            [
              {
                text: item.module.categories[i].name,
                style: "tableHeader",
                rowSpan: 2,
                alignment: "left",
              },
              { text: "Points", style: "tableHeader", alignment: "center" },
              { text: "total", style: "tableHeader", alignment: "center" },
              { text: "Percent", style: "tableHeader", alignment: "center" },
            ],
            [
              {},
              {
                text: modifiedItem.module.categories[i].score,
                style: "tableHeader",
                alignment: "center",
              },
              {
                text: modifiedItem.module.categories[i].totalQuestionScore,
                style: "tableHeader",
                alignment: "center",
              },
              {
                text: modifiedItem.module.categories[i].percentCat + "%",
                style: "tableHeader",
                alignment: "center",
              },
            ],
          ],
        },
      });
      this.content.push({
        table: {
          widths: ["69.5%", "8.5%", "7.5%", "5.5%", "9%"],
          // heights:[10,10],
          headerRows: 2,
          // keepWithHeaderRows: 1,
          body: [
            [
              { text: "questions", alignment: "center", fillColor: "#eeeeee" },
              { text: "answer", alignment: "center", fillColor: "#eeeeee" },
              { text: "Points", alignment: "center", fillColor: "#eeeeee" },
              { text: "total", alignment: "center", fillColor: "#eeeeee" },
              { text: "Percent", alignment: "center", fillColor: "#eeeeee" },
            ],
            [
              {
                fillColor: "#eeeeee",
                text: "audit category total",
                style: "tableHeader",
                alignment: "center",
              },
              { fillColor: "#eeeeee", text: "" },
              {
                fillColor: "#eeeeee",
                text: modifiedItem.module.categories[i].score,
                style: "tableHeader",
                alignment: "center",
              },
              {
                fillColor: "#eeeeee",
                text: modifiedItem.module.categories[i].totalQuestionScore,
                style: "tableHeader",
                alignment: "center",
              },
              {
                fillColor: "#eeeeee",
                text: modifiedItem.module.categories[i].percentCat + "%",
                style: "tableHeader",
                alignment: "center",
              },
            ],
          ],
        },
      });
  
      for (let ii = 0; ii < modifiedItem.module.categories[i].questions.length; ii++) {
        
            var score;
            var questionpercent;
            questionpercent = ( modifiedItem.module.categories[i].questions[ii].score * 100) / modifiedItem.module.quesfullscore;
      
            if ( modifiedItem.module.categories[i].questions.answerindex == "na") {
              score = "na";
              questionpercent = "na";
            } else {
              score = modifiedItem.module.quesfullscore;
            }
      
            this.content.push({
              table: {
                widths: ["69.5%", "8.5%", "7.5%", "5.5%", "9%"],
                body: [
                  [
                    {
                      stack: [
                        { text: modifiedItem.module.categories[i].questions[ii].englishname + " ?" },
                    { text: this.reverseText(modifiedItem.module.categories[i].questions[ii].arabicname + " ؟"), font: 'Cairo', style: 'rtlStyle' },
                        "comments & choices  ",
                       this.reverseText(modifiedItem.module.categories[i].questions[ii].comment),
      
                        {
                          ul:  modifiedItem.module.categories[i].questions[ii].englishansweredchoices,
                        },
                        {
                          table: {
                            body: [modifiedItem.module.categories[i].questions[ii].photos],
                          },
                        },
                      ],
                    },
                    {
                      text: modifiedItem.module.categories[i].questions[ii].answerindex,
                      style: "tableHeader",
                      alignment: "center",
                    },
                    {
                      text: modifiedItem.module.categories[i].questions[ii].score,
                      style: "tableHeader",
                      alignment: "center",
                    },
                    { text: score, style: "tableHeader", alignment: "center" },
                    {
                      text: questionpercent + "%",
                      style: "tableHeader",
                      alignment: "center",
                    },
                  ],
                ],
              },
            });

          
        
      }
    }


    
console.log(this.vbarChartBase64,"this.vbarChartBase64");



  this.content.push(
    {
      table: {
        widths: ["100%"],
        body: [
          [
            { fillColor: "#eeeeee", alignment: "center", text: "Scoring Categories" }
          ],
          [
            {
            border:[false,false,false,false],
              image: this.vbarChartBase64,
              alignment: "center",
              width: this.CHART_WIDTH,
              height: 300
            }
          ],
        ],
      },
    }
  );


   




    this.content.push(

      {
        table: {
          widths: ["100%"],
          body: [
            [
              {
                fillColor: "#eeeeee",
                alignment: "center",
                text: "Scoring Department",
              }
            ],
            [
               {
                border:[false,false,false,false],
                 image: this.hbarChartBase64,
                 width: this.CHART_WIDTH,
                 alignment: "center",
               height: this.createhbarCharthieght
              
             }
            ],
          ],
        },
      }
    );



    if(this.actionplanstatus){
    this.content.push(
        {
          table: {
            widths: ["50%","50%"],
            body: [
              [
                {
                  fillColor: "#eeeeee",
                  alignment: "center",
                  text: "Standard Compilation",
                },{
                  fillColor: "#eeeeee",
                  alignment: "center",
                  text: "Action Plan",
                }
              ],
              [
                 {
                  border:[false,false,false,false],
                  image: this.sandtardCompilationDoughnutChartBase64,
                  alignment: "center",
                  width: 250,
                  height: 100
                },
                {
                  border:[false,false,false,false],
                  image: this.actionPlanDoughnutChartBase64,
                  alignment: "center",
                  width: 250,
                  height: 100
                }
              ],
            ],
          },
        }
      );
    }else{
      this.content.push(

        {
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  fillColor: "#eeeeee",
                  alignment: "center",
                  text: "Standard Compilation",
                }
              ],
              [
                 {
                  border:[false,false,false,false],
                  image: this.sandtardCompilationDoughnutChartBase64,
                  alignment: "center",
                  width: 250,
                  height: 100
                }
              ],
            ],
          },
        }
      );
    }



this.generatePDF(item);
   
   })
   .catch((error) => {
     console.error("Error occurred during image data fetching and processing:", error);
   });
  }







  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.clientaudit);
  }
  getclientbyid() {
    console.log(this.id)
    this.GeneralService.getclientbyid(this.id).then(res => {
      this.client = res;
      console.log(this.client)
      this.clientmodule = this.client[0].moudlerf
      console.log(this.clientmodule)

    });

  }
  onClientModuleSelected(event) {
    this.clientmoduleSelected = !this.clientmoduleSelected;
    if (!event) {
      this.clientmoduleSelected = false;
    }
    else {
      this.clientmoduleSelected = true;

    }

    this.selectedModuleval = event.id;
    this.selectedModuleName = event.name
    console.log(this.clientmoduleSelected);

  }

  onBranchSelected(event) {
    this.branchSelected = !this.branchSelected;
    if (!event) {
      this.branchSelected = false;
    }
    else {
      this.branchSelected = true;

    }
    this.selectedBranchval = event.id;
    this.selectedBranchName = event.name

    console.log(this.branchSelected);

  }


  getBranchByClientId() {
    this.GeneralService.getBranchByClientId(this.id).then(res => {
      console.log(res)
      this.Branches = res;
    })
  }

  search(form: NgForm) {
    this.dataSource = new MatTableDataSource([]);
    const formData = {
      startDate: this.form.value.startdate,
      endDate: this.form.value.enddate,
      selectedModule: this.selectedModuleval,
      selectedBranch: this.selectedBranchval
    };
    this.GeneralService.getAuditsForReports(formData.startDate, formData.endDate, formData.selectedModule, formData.selectedBranch).then(res => {
      if(res.length != 0){
        this.dataSource = new MatTableDataSource(res);
      }
      else{
        throw new Error('No data found');
      }
    }).catch(error => {
      console.error('Error fetching audit reports:', error);
      Swal.fire({
        title: "Error",
        text: error.message || "Failed to fetch audit reports",
        icon: 'error'
      });
    });


  }

  async getUserById(userId: string): Promise<void> {
    try {
      const user = await this.GeneralService.GetUserWithID(userId);
      this.auditerdata = user;
       console.log(this.auditerdata);
      // Handle user data here (e.g., assign to a component property)
    } catch (error) {
      console.error('Error fetching user:', error);
      // Handle error (e.g., show error message to user)
    }
  }
  







  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }


  

  async loadDataAndCharts(item) {

    // Show the loader when the data starts loading
    this.LoaderServiceService.show();
    await this.getUserById(item.auditerId);

    this.GeneralService.getAuditByIdForReportCharts(item.id)
      .then(data => {
        this.auditCharts = data;
        this.cdr.detectChanges();
  
        // Wait for all charts to be created before proceeding
        return Promise.all(this.auditCharts.map((_, index) => {
          this.gaugeValue = _.totalscore;
  
          return new Promise<void>(resolve => {
            setTimeout(() => {
              // Initialize chart data
              this.labelsVchart = [];
              this.DataVchart = [];
              this.labelsHchart = [];
              this.DataHchart = [];
              this.DataSandtardcompilationdoughnut = [];
  
              // Populate chart data for categories
              _.categories.forEach(category => {
                this.labelsVchart.push(category.categoryname);
                this.DataVchart.push(category.percent);
              });
  
              // Populate chart data for departments
              _.departments.forEach(department => {
                this.DataHchart.push(department.percent);
                this.labelsHchart.push(department.departmentname);
              });
  
              // Standard compilation checks
              if (!_.Standardcompilation?.c) {
                _.Standardcompilation.c = 0;
              }
              if (!_.Standardcompilation?.m) {
                _.Standardcompilation.m = 0;
              }
              if (!_.Standardcompilation?.nc) {
                _.Standardcompilation.nc = 0;
              }
  
              // Push data for standard compilation chart
              this.DataSandtardcompilationdoughnut.push(_.Standardcompilation.c);
              this.DataSandtardcompilationdoughnut.push(_.Standardcompilation.nc);
              this.DataSandtardcompilationdoughnut.push(_.Standardcompilation.m);
  
              // Create charts
              this.createvbarChart(index, this.labelsVchart, this.DataVchart);
              this.createhbarChart(index, this.labelsHchart, this.DataHchart);
              this.sandtardcompilationdoughnutChart(index, this.DataSandtardcompilationdoughnut);
  
              // Fetch additional data
              this.getActionPlanByAuditid(_.auditid, index);
              this.getimage(item);
  
              // Resolve the promise after all operations for this chart are done
              resolve();

            }, 0);
          });
        }));
      })
      .then(() => {
        // Hide the loader after all charts have been created
        
      })
      .catch(error => {
        console.error('Error:', error);
        // Hide the loader in case of an error
      });
  }
  

  // loadDataAndCharts(item) {
  //   this.LoaderServiceService.show();

  //   this.GeneralService.getAuditByIdForReportCharts(item.id)
  //     .then(data => {

  //       this.auditCharts = data;
  //       console.log(this.auditCharts.totalscore);
  //       this.cdr.detectChanges();
  //       return Promise.all(this.auditCharts.map((_, index) => {
  //         this.gaugeValue = _.totalscore
  //         return new Promise<void>(resolve => { // Specify Promise<void>
  //           setTimeout(() => {
  //             this.labelsVchart = []
  //             this.DataVchart = []
  //             this.labelsHchart = []
  //             this.DataHchart = []
  //             this.DataSandtardcompilationdoughnut = [];
  //             _.categories.forEach(categories => {
  //               this.labelsVchart.push(categories.categoryname)
  //               this.DataVchart.push(categories.percent)
  //             });
  //             _.departments.forEach(departments => {
  //               this.DataHchart.push(departments.percent)
  //               this.labelsHchart.push(departments.departmentname)
  //             });
  //             if (!_.Standardcompilation?.c) {
  //               _.Standardcompilation.c = 0
  //             }
  //             if (!_.Standardcompilation?.m) {
  //               _.Standardcompilation.m = 0
  //             }
  //             if (!_.Standardcompilation?.nc) {
  //               _.Standardcompilation.nc = 0
  //             }
  //             this.DataSandtardcompilationdoughnut.push(_.Standardcompilation.c)
  //             this.DataSandtardcompilationdoughnut.push(_.Standardcompilation.nc)
  //             this.DataSandtardcompilationdoughnut.push(_.Standardcompilation.m)
  //             this.createvbarChart(index, this.labelsVchart, this.DataVchart);
  //             this.createhbarChart(index, this.labelsHchart, this.DataHchart);
  //             this.sandtardcompilationdoughnutChart(index, this.DataSandtardcompilationdoughnut)

  //             this.getActionPlanByAuditid(_.auditid, index)
  //             this.getimage(item)

  //             resolve();
  //           }, 0);
  //           this.LoaderServiceService.hide();

  //         });
  //       }));

  //       // Create charts after data is available and elements are rendered

  //     })
  //     .catch(error => {
  //       console.error('Error:', error);
  //     });
  // }




// Constants for A4 dimensions in points
 A4_WIDTH_PT = 595;
 A4_MARGIN = 40; // Margins on each side
 CHART_WIDTH = this.A4_WIDTH_PT - (2 * this.A4_MARGIN); // Available width for chart


 createhbarChart(index: number, labels: any, data: any): void {
  this.createBarChart = this.destroyChart(this.createBarChart);
  const canvasId = `hmyChart_${index}`;
  Chart.register(ChartDataLabels);

  const ctx = document.getElementById(canvasId) as HTMLCanvasElement;
  if (!ctx) return;

  // Calculate dimensions based on number of labels
  const labelCount = labels.length;
  const minHeight = 400; // Increased minimum height
  const heightPerLabel = 50; // Increased height per label
  const calculatedHeight = Math.max(minHeight, labelCount * heightPerLabel);
  
  // Set canvas dimensions for PDF
  ctx.style.width = `${this.CHART_WIDTH}px`;
  ctx.style.height = `${calculatedHeight}px`;
  this.createhbarCharthieght = calculatedHeight;
  // Set high-resolution canvas dimensions
  ctx.width = this.CHART_WIDTH * 2;
  ctx.height = calculatedHeight;

  const base64ImagePlugin = {
    id: 'base64ImagePlugin',
    afterDraw: (chart) => {
      if (chart.canvas.id === canvasId) {
        this.hbarChartBase64 = chart.toBase64Image();
      }
    }
  };

  this.createBarChart = new Chart(canvasId, {
    type: 'bar',
    data: {
      datasets: [{
        label: '',
        data: data,
        backgroundColor: this.colorarray.slice(0, data.length),
        borderColor: this.colorarray.slice(0, data.length),
        borderWidth: 1,
        maxBarThickness: 20,
        barPercentage: 0.6, // Slightly reduced to prevent overflow
        categoryPercentage: 0.7,
      }],
      labels: labels
    },
    options: {
      responsive: false,
      maintainAspectRatio: false,
      animation: { duration: 0 },
      indexAxis: 'y',
      layout: {
        padding: {
          left: 0, // Add padding for labels
          right: 0,
          top: 0,
          bottom: 0
        }
      },
      plugins: {
        tooltip: { enabled: false },
        datalabels: {
          anchor: 'center',
          align: 'center',
          color: 'white',
          font: { 
            size: 14,
            weight: 'bold'
          },
          formatter: (value) => value.toString()
        },
        legend: { display: false }
      },
      scales: {
        x: {
          beginAtZero: true,
          min: 0,
          max: 100,
          grid: {
            display: true,
            drawOnChartArea: true
          },
          ticks: {
            font: {
              size: 5
            }
          }
        },
        y: {
          grid: { display: false },
          ticks: {
            color: 'black',
            font: {
              size: 14,
              weight: 'bold'
            },
            // Ensure labels don't get cut off
            padding: 0,
            // Add callback to handle long labels
            callback: function(value) {
              const label = this.getLabelForValue(value as number);
              // Return full label without truncation
              return label;
            }
          }
        }
      }
    },
    plugins: [base64ImagePlugin]
  });
}

createvbarChart(index: number, labels: any, data: any): void {
  this.createvBarChart = this.destroyChart(this.createvBarChart);
  const canvasId = `vmyChart_${index}`;
  
  const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
  
  // Set fixed dimensions for PDF
  canvas.style.width = `${this.CHART_WIDTH}px`;
  canvas.style.height = '300px';
  
  // Set actual canvas dimensions (for better resolution)
  canvas.width = this.CHART_WIDTH * 2;
  canvas.height = 600; // Double height for better resolution

  Chart.register(ChartDataLabels);
  
  const base64ImagePlugin = {
    id: 'base64ImagePlugin',
    afterDraw: (chart) => {
      if (chart.canvas.id === canvasId) {
        this.vbarChartBase64 = chart.toBase64Image();
      }
    }
  };

  this.createvBarChart = new Chart(canvasId, {
    type: 'bar',
    data: {
      datasets: [{
        label: '',
        data: data,
        backgroundColor: this.colorarray.slice(0, data.length),
        borderColor: this.colorarray.slice(0, data.length),
        borderWidth: 2,
        maxBarThickness: 35,
        barPercentage: 0.9,
        categoryPercentage: 0.9,
      }],
      labels: labels
    },
    options: {
      responsive: false,
      maintainAspectRatio: false,
      animation: { duration: 0 },
      plugins: {
        tooltip: { enabled: false },
        datalabels: {
          anchor: 'center',
          align: 'center',
          color: 'white',
          font: { size: 12 },
          formatter: (value) => value.toString()
        },
        legend: { display: false }
      },
      scales: {
        x: {
          grid: { display: false },
          ticks: {
            color: 'black',
            font: {
              size: 12,
              weight: 'bold'
            }
          }
        },
        y: {
          beginAtZero: true,
          min: 0,
          max: 100,
          grid: { display: true }
        }
      }
    },
    plugins: [base64ImagePlugin]
  });
}










//   createhbarChart(index: number, labels: any, data: any): void {
//     // destroyChart()
//     this.createBarChart = this.destroyChart(this.createBarChart);
//     const canvasId = `hmyChart_${index}`;
//     Chart.register(ChartDataLabels);

//     const ctx = document.getElementById(canvasId) as HTMLCanvasElement;
//     if (!ctx) return;
//     const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
//     canvas.style.width = '400px';   // PDF width
//     // ضبط ارتفاع الكانفس بناءً على عدد الأعمدة
//     ctx.style.height = `${Math.max(300, labels.length * 40)}px`;
//     this.createhbarCharthieght  = Math.max(300, labels.length * 40 );
      
//     const base64ImagePlugin = {
//       id: 'base64ImagePlugin',
//       afterDraw: (chart) => {
//           // Check if it's the desired chart instance
//           if (chart.canvas.id === canvasId) {
//               this.hbarChartBase64 = chart.toBase64Image();
//               console.log(this.hbarChartBase64, "base64 chart data");
//           }
//       }
//   };
//      this.createBarChart = new Chart(canvasId, {
//       type: 'bar', // Use 'bar' type
//       data: {
//         datasets: [{
//           label: '',
//           data: data,
//           backgroundColor: this.colorarray.slice(0, data.length),
//           borderColor: this.colorarray.slice(0, data.length),
//           borderWidth: 2,
//           maxBarThickness: 20, // ✅ Large bars without overlap
//           barPercentage: 1.0, // ✅ Adjust width to fit well
//           categoryPercentage: 1.0, // ✅ Ensures full space usage
//         }],
//         labels: labels // Add labels for the bars
//       },
//       options: {
//         responsive: true, // ✅ يجعل المخطط متجاوبًا
//         maintainAspectRatio: false, // ✅ يسمح له بتغيير الحجم حسب الحاجة
//         animation: {
//           duration: 0  // Set the animation duration to 0 to disable animation
//         },
//         indexAxis: 'y', // Specify horizontal orientation
//         plugins: {
//           tooltip: {
//             enabled: false // Disable default tooltip
//           },
//           datalabels: { // Plugin for displaying data labels
//             anchor: 'center',
//             align: 'center',
//             color: 'white', // Text color
//             font: {
//               size: 14 // Font size
//             },
//             formatter: function (value: any) { // Format function for the data labels
//               return value; // Display the value as it is
//             },

//           }, 
//          legend: { display: false } // ✅ عرض وسيلة الإيضاح
//         },
//         scales: {
//           x: { // Configure X scale
//             beginAtZero: true,
//             min: 0, // Set minimum value
//             max: 100,
//             // ticks: {
//             //   color: 'black',
//             //   font: {
//             //     size: 16,    // Adjust this value as needed
//             //     weight: 'bold'  // Make text bold
//             //   }
//             // }
//           },
//           y: {
//             // Set maximum value // Configure Y scale
//             grid: {
//               // color: 'rgba(60,60,60, 1)' // Change the border color for Y scale
//             },
//             ticks: {
//               color: 'black',
//               font: {
//                 size: 16,    // Increase font size
//                 weight: 'bold'  // Make text bold
//               }
//             }
//           }
//         },
        
//       },
//       plugins: [base64ImagePlugin]
//     });
//   //   myChart.on('complete', () => {
//   //     this.hbarChartBase64 = myChart.toBase64Image();
//   //     console.log(this.hbarChartBase64, "base64 chart data");
//   // });
  
// console.log(this.hbarChartBase64,"base64 chart data");
   
//   }





//   createvbarChart(index: number, labels: any, data: any): void {
// this.createvBarChart = this.destroyChart(this.createvBarChart)
//     const canvasId = `vmyChart_${index}`;
//     const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
//     canvas.style.width = '400px';   // PDF width
//     canvas.style.height = '300px';  // PDF height
//     canvas.width = 400;  // Actual canvas width
//     canvas.height = 300; // Actual canvas height

//     Chart.register(ChartDataLabels);
//     const base64ImagePlugin = {
//       id: 'base64ImagePlugin',
//       afterDraw: (chart) => {
//           // Check if it's the desired chart instance
//           if (chart.canvas.id === canvasId) {
//               this.vbarChartBase64 = chart.toBase64Image();
//               console.log(this.hbarChartBase64, "base64 chart data");
//           }
//       }
//   };
//      this.createvBarChart = new Chart(canvasId, {
//       type: 'bar',
//       data: {
//         datasets: [{
//           label: '',
//           data: data,
//           backgroundColor: this.colorarray.slice(0, data.length),
//           borderColor: this.colorarray.slice(0, data.length),
//           borderWidth: 2,
//           maxBarThickness: 40, // ✅ Large bars without overlap
//           barPercentage: 1.0, // ✅ Adjust width to fit well
//           categoryPercentage: 1.0, // ✅ Ensures full space usage
//         }],
//         labels: labels
//       },
//       options: {
//         responsive: true,
//         maintainAspectRatio: false,
//         animation: {
//           duration: 0  // Set the animation duration to 0 to disable animation
//         },
//         plugins: {
//           tooltip: {
//             enabled: false // Disable default tooltip
//           },

//           datalabels: { // Plugin for displaying data labels
//             anchor: 'center',
//             align: 'center',
//             color: 'white', // Text color
//             font: {
//               size: 14 // Font size
//             },
//             formatter: function (value: any) { // Format function for the data labels
//               return value; // Display the value as it is
//               /// return value + '%';  Display the value as it is

//             }
//           },
//           legend: { display: false } // ✅ عرض وسيلة الإيضاح

//         },
//         scales: {

//           x: {
//             grid: {

//               // color: 'rgba(60,60,60, 1)' // Change the border color for X scale
//             },
//             ticks: {
//               color: 'black' // Change the color of tick marks on X scale
//             },

//           },
//           y: {
//             beginAtZero: true,
//             min: 0, // Set minimum value
//             max: 100,

//           }
//         }
//       },
//       plugins: [base64ImagePlugin]
//     });



//   }


  actionplandoughnutChart(index: number, open: any, close: any, underprocess: any): void {
    // const chartContainerId = `chartContainerName_${index}`;
    this.actionPlanDoughnutChart = this.destroyChart(this.actionPlanDoughnutChart)

    const canvasId = `actionplandoughnutChart_${index}`;
    Chart.register(ChartDataLabels);
    const base64ImagePlugin = {
      id: 'base64ImagePlugin',
      afterDraw: (chart) => {
          // Check if it's the desired chart instance
          if (chart.canvas.id === canvasId) {
              this.actionPlanDoughnutChartBase64 = chart.toBase64Image();
              console.log(this.hbarChartBase64, "base64 chart data");
          }
      }
  };
    this.actionPlanDoughnutChart = new Chart(canvasId, {
      type: 'doughnut',
      data: {
        datasets: [{
          label: '',
          data: [open, close, underprocess],
          backgroundColor: ['rgb(255,0,0)', 'rgb(60, 146, 186)', 'rgb(255, 160, 0)'
          ],

          borderWidth: 1,

        }],
        labels: ['open', 'close', 'underprocess']
      },
      options: {
        responsive: false,
        animation: {
          duration: 0  // Set the animation duration to 0 to disable animation
        },
        plugins: {
          tooltip: {
            enabled: false // Disable default tooltip
          },

          datalabels: { // Plugin for displaying data labels
            anchor: 'center',
            align: 'center',
            color: 'white', // Text color
            font: {
              size: 14 // Font size
            },
            formatter: function (value: any) { // Format function for the data labels
              return value + "%"; // Display the value as it is
            }
          }
        },

      },
      plugins: [base64ImagePlugin]
    });
    
  }



  sandtardcompilationdoughnutChart(index: number, data: any): void {
    this.sandtardCompilationDoughnutChart = this.destroyChart(this.sandtardCompilationDoughnutChart)

    // const chartContainerId = `chartContainerName_${index}`;
    const canvasId = `sandtardcompilationdoughnutChart_${index}`;
    Chart.register(ChartDataLabels);
    const base64ImagePlugin = {
      id: 'base64ImagePlugin',
      afterDraw: (chart) => {
          // Check if it's the desired chart instance
          if (chart.canvas.id === canvasId) {
              this.sandtardCompilationDoughnutChartBase64 = chart.toBase64Image();
              console.log(this.hbarChartBase64, "base64 chart data");
          }
      }
  };
  this.sandtardCompilationDoughnutChart = new Chart(canvasId, {
      type: 'doughnut',
      data: {
        datasets: [{
          label: '',
          data: data,
          backgroundColor: ['rgb(60, 146, 186)',
            'rgb(255,0,0)',
            'rgb(255, 160, 0)'],
          borderWidth: 1,

        }],
        labels: ['c', 'nc', 'm']
      },
      options: {
        responsive: false,
        animation: {
          duration: 0  // Set the animation duration to 0 to disable animation
        },

        plugins: {
          tooltip: {
            enabled: false // Disable default tooltip
          },

          datalabels: { // Plugin for displaying data labels
            anchor: 'center',
            align: 'center',
            color: 'white', // Text color
            font: {
              size: 14 // Font size
            },
            formatter: function (value: any) { // Format function for the data labels
              return value + "%"; // Display the value as it is
            }
          }
        },

      },
      plugins: [base64ImagePlugin]
    });

  }

  getActionPlanByAuditid(id, LastAuditIndex) {
    this.GeneralService.getActionPlanByAuditid(id).then(res => {
      return new Promise<any>((resolve, reject) => {
        
        console.log(res)
      
        const today = new Date();
        this.ActionPlanOpen = res.filter(x => x.done == "false" && new Date(x.duedate) < today).length
        this.ActionPlanClose = res.filter(x => x.done == "true").length
        this.ActionPlanUnderProcess = res.filter(x => x.done == "false" && new Date(x.duedate) > today).length

        this.ActionPlanOpen = parseFloat(Number(Number(this.ActionPlanOpen * 100) / Number(res.length)).toFixed(1))
        this.ActionPlanClose = parseFloat(Number(Number(this.ActionPlanClose * 100) / Number(res.length)).toFixed(1))
        this.ActionPlanUnderProcess = parseFloat(Number(Number(this.ActionPlanUnderProcess * 100) / Number(res.length)).toFixed(1))

        console.log(this.ActionPlanOpen, "ActionPlanOpen")
        console.log(this.ActionPlanClose, "ActionPlanClose")
        console.log(this.ActionPlanUnderProcess, "ActionPlanUnderProcess")

        if(res.length > 0){
          this.actionplanstatus = true;
          this.actionplandoughnutChart(LastAuditIndex, this.ActionPlanOpen, this.ActionPlanClose, this.ActionPlanUnderProcess)
        }else{
          this.actionplanstatus = false;
        }
                  // this.actionplandoughnutChart(LastAuditIndex, this.ActionPlanOpen, this.ActionPlanClose, this.ActionPlanUnderProcess)

      }).catch(error => {
        // This block is executed if there is an error with the API call
        console.error("API error:", error);
        // Handle the error as needed, e.g., display an error message to the user
      });
    })

  }




















  clear() {
    this.form.resetForm();
    this.branchSelect.clearModel();
    this.moduleSelect.clearModel();


    this.dataSource = new MatTableDataSource(this.clientaudit);

  }

  destroyChart(chart) {
    if (chart) {
      chart.destroy(); // Destroy the existing chart instance
      return chart = null;
    }
  }








}
